import styled from "@emotion/styled";
import { getBorderColor } from "./RadioIcon";
import { radioInnerDotTheme } from "./radioTheme";
export const RadioInnerDot = styled("div")`
    background-color: ${getBorderColor};
    border-radius: 50%;
    opacity: ${_ref => {
  let {
    isChecked,
    themeMode
  } = _ref;
  return isChecked ? radioInnerDotTheme.opacity.checked(themeMode) : radioInnerDotTheme.opacity.unchecked(themeMode);
}};
    height: ${_ref2 => {
  let {
    size
  } = _ref2;
  return size === "large" ? 10 : 8;
}}px;
    width: ${_ref3 => {
  let {
    size
  } = _ref3;
  return size === "large" ? 10 : 8;
}}px;

    // We don't want this to affect the hover/active/etc. states.
    pointer-events: none;
`;
//# sourceMappingURL=RadioInnerDot.js.map